import namespace from './namespace';
import utils from './../../utils';

export default {
    [namespace.getters.TFS_VALUES]: (state) => {
        if (state[namespace.state.AVAILABLE_VALUES] === undefined) {
            return [];
        }
        return Object.values(state[namespace.state.AVAILABLE_VALUES])
                     .filter(value => value.visible && value.kind === namespace.kinds.TFS)
                     .sort(utils.compareByLabel);
    },
    [namespace.getters.JIRA_VALUES]: (state) => {
        if (state[namespace.state.AVAILABLE_VALUES] === undefined) {
            return [];
        }
        return Object.values(state[namespace.state.AVAILABLE_VALUES])
                     .filter(value => value.visible && value.kind === namespace.kinds.JIRA)
                     .sort(utils.compareByLabel);
    },
    [namespace.getters.AVAILABLE_VALUES]: (state, getters) => {     
        return {
            TfsValues: getters[namespace.getters.TFS_VALUES],
            JiraValues: getters[namespace.getters.JIRA_VALUES]
        }
    },
    [namespace.getters.MAPPINGS]: (state, getters) => {
        return state[namespace.state.MAPPINGS];
    },
    [namespace.getters.IS_LOADER_VISIBLE]: (state) => {
        return state[namespace.state.LOADER_VISIBLE];
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/mappings/getters.js